import React from "react"
import { Form, Col, Row } from "react-bootstrap"
import { FieldArray } from "formik"
import Icon from "../../Utils/Icon"

import * as styles from "./Styles/BusinessHourField.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
import {
  openingTimeRangeFilter,
  closingTimeRangeFilter,
} from "../../Utils/business_hour"
const cn = classNames.bind(styles)

const times = []
const hourRange = Array(30)
const minutesRange = ["00", 30]
for (let i = 0; i < hourRange.length; i++) {
  for (let j = 0; j < minutesRange.length; j++) {
    const hourValue = i % 24
    const hourLabelText = ("00" + i).slice(-2)
    const hourValueText = ("00" + hourValue).slice(-2)
    times.push({
      label: `${hourLabelText}:${minutesRange[j]}`,
      value: `${hourValueText}:${minutesRange[j]}`,
    })
  }
}

const RangeSelector = ({ value, onChange, range, ...props }) => (
  <Form.Control
    as="select"
    value={value}
    onChange={onChange}
    disabled={props.isAllday || props.isHoliday}
  >
    {range.map((time) => (
      <option key={time.label} value={time.value}>
        {time.label}
      </option>
    ))}
  </Form.Control>
)

const DeleteTimeLink = ({ index, arrayHelpers }) => (
  <a
    href="#"
    onClick={() => {
      arrayHelpers.remove(index)
    }}
  >
    <Icon
      className={styles.removeIcon__icon}
      type="feather"
      name="trash-2"
      attr={{ width: 16, height: 16 }}
    />
  </a>
)

const AppendTimeLink = ({ arrayHelpers, ...props }) => (
  <React.Fragment>
    {!props.isAllday && !props.isHoliday && (
      <a
        className={styles.addBusinessHour}
        href="#"
        onClick={() => {
          arrayHelpers.push({
            dayOfWeek: props.wday,
            openingTime: "00:00",
            closingTime: "23:30",
          })
        }}
      >
        <Icon
          className={styles.plusIcon}
          type="feather"
          name="plus"
          attr={{ width: 14, height: 14 }}
        />
        <span>営業時間を追加</span>
      </a>
    )}
    {(props.isAllday || props.isHoliday) && (
      <span>営業時間は追加できません</span>
    )}
  </React.Fragment>
)

const BusinessHourPCFields = (props) => (
  <FieldArray
    name={props.name}
    render={(arrayHelpers) => (
      <React.Fragment>
        {props.targets.map((target, i) => (
          <React.Fragment key={target.index}>
            {i == 0 && (
              <Row>
                <Col sm={4}>
                  <Form.Label>開始</Form.Label>
                </Col>
                <Col sm={1} className="l-centering" />
                <Col sm={4}>
                  <Form.Label>終了</Form.Label>
                </Col>
                <Col />
              </Row>
            )}
            <Row className={styles.businessHourSelect}>
              <Col sm={4}>
                <Form.Group
                  className={styles.nomargins}
                  controlId={`${props.name}.${target.index}.openingTime`}
                >
                  <RangeSelector
                    range={target.openingTimeRange}
                    value={target.hours.openingTime}
                    {...props}
                  />
                </Form.Group>
              </Col>
              <Col sm={1} className={cn("l-centering", "nopaddings")}>
                〜
              </Col>
              <Col sm={4}>
                <Form.Group
                  className={styles.nomargins}
                  controlId={`${props.name}.${target.index}.closingTime`}
                >
                  <RangeSelector
                    range={target.closingTimeRange}
                    value={target.hours.closingTime}
                    {...props}
                  />
                </Form.Group>
              </Col>
              <Col className={cn("l-flex", "removeIcon", "nopaddings")}>
                <DeleteTimeLink
                  index={target.index}
                  arrayHelpers={arrayHelpers}
                />
              </Col>
            </Row>
          </React.Fragment>
        ))}
        <AppendTimeLink arrayHelpers={arrayHelpers} {...props} />
      </React.Fragment>
    )}
  />
)

const BusinessHourSPFields = (props) => (
  <FieldArray
    name={props.name}
    render={(arrayHelpers) => (
      <React.Fragment>
        {props.targets.map((target) => (
          <div className={styles.formGroup} key={target.index}>
            <Form.Label>開始</Form.Label>
            <Form.Group controlId={`${props.name}.${target.index}.openingTime`}>
              <RangeSelector
                range={target.openingTimeRange}
                value={target.hours.openingTime}
                {...props}
              />
            </Form.Group>
            <Form.Label>終了</Form.Label>
            <Form.Group controlId={`${props.name}.${target.index}.closingTime`}>
              <RangeSelector
                range={target.closingTimeRange}
                value={target.hours.closingTime}
                {...props}
              />
            </Form.Group>
            <div className={styles.delete}>
              <DeleteTimeLink
                index={target.index}
                arrayHelpers={arrayHelpers}
              />
            </div>
          </div>
        ))}
        <AppendTimeLink arrayHelpers={arrayHelpers} {...props} />
      </React.Fragment>
    )}
  />
)

const BusinessHourField = (props) => {
  const targets = []
  for (let i = 0; i < props.businessHours.length; i++) {
    const h = props.businessHours[i]
    if (h.dayOfWeek == props.wday && h.openingTime && h.closingTime) {
      const openingTimeNumber = parseInt(h.openingTime.replace(":", ""))
      const closingTimeNumber = parseInt(h.closingTime.replace(":", ""))
      targets.push({
        hours: h,
        index: i,
        openingTimeRange: times.filter(
          openingTimeRangeFilter(openingTimeNumber, closingTimeNumber)
        ),
        closingTimeRange: times.filter(
          closingTimeRangeFilter(openingTimeNumber)
        ),
      })
    }
  }

  return (
    <React.Fragment>
      <div className={cn("businessHours--sp")}>
        <BusinessHourSPFields targets={targets} {...props} />
      </div>
      <div className={cn("businessHours--pc")}>
        <BusinessHourPCFields targets={targets} {...props} />
      </div>
    </React.Fragment>
  )
}

export default BusinessHourField
